import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class SundialForgotten1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.SUNDIAL_FORGOTTEN1;
}

export default SundialForgotten1PoiTileEntity;
